import React from "react";

import { useSsoUrls } from "hooks/useSsoUrls";

const PromoCodeCTA = () => {
  const { signInUrl } = useSsoUrls();
  return (
    <>
      <div
        data-testid="promo-code-cta"
        className="bg-leafly-white w-full py-4 flex items-center flex-col"
      >
        <div style={{ fontWeight: 600 }}>Have a promo code?</div>
        <div>To gain access to promo codes,</div>
        <a className="text-green underline" href={signInUrl}>
          create an account or sign in
        </a>
      </div>
    </>
  );
};

export default PromoCodeCTA;
